<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        DateRangePicker(:value="dateRange" @update="getData")
      .form-group.col-md-3.col-2
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            i.fa.fa-map-marker
          DebounceInput(autofocus type="text" v-model="login_ip" :placeholder="$t('ui.login_ip')" @enter="getLogList(true)" size="sm")
      .form-group.col-2.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.status') }}
          b-form-select(v-model="loginStatus" @change="getLogList(true)" :disabled="loading" size="sm")
            option(value=99) {{ $t('ui.all') }}
            option(value=0) {{ $t('ui.failed') }}
            option(value=1) {{ $t("ui.success") }}             
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getLogList(true)"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="5%")
                  span #
                th(width="12%" @click="sortOrder('contact_phone')")
                  span(:title="$t('ui.contact_phone')") {{ $t('ui.contact_phone') }}
                  .float-right
                    i(:class="changeSortKey('contact_phone')")
                th.text-center(width="11%" @click="sortOrder('action_type')")
                  span(:title="$t('ui.action_status')") {{ $t('ui.action_status') }}
                  .float-right
                    i(:class="changeSortKey('action_type')")
                th(width="12%" @click="sortOrder('domain_name')")
                  span(:title="$t('ui.domain_name')") {{ $t('ui.domain_name') }}
                  .float-right
                    i(:class="changeSortKey('domain_name')")
                th(width="12%" @click="sortOrder('login_ip')")
                  span(:title="$t('ui.login_ip')") {{ $t('ui.login_ip') }}
                  .float-right
                    i(:class="changeSortKey('login_ip')")
                th(width="35%" @click="sortOrder('browser_agent')")
                  span(:title="$t('ui.browser_agent')") {{ $t('ui.browser_agent') }}
                  .float-right
                    i(:class="changeSortKey('browser_agent')")
                th.text-right(width="15%" @click="sortOrder('action_date')")
                  span(:title="$t('ui.action_date')") {{ $t('ui.action_date') }}
                  .float-right
                    i(:class="changeSortKey('action_date')")
            tbody.clusterize-content
              tr(v-if="logList.length == 0")
                td(:colspan="7").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in logList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.contact_phone") {{ item.contact_phone }}
                td.text-center
                  span(:class="{'badge badge-success': item.action_type.toUpperCase() == 'SUCCESS', 'badge badge-danger': item.action_type.toUpperCase() == 'FAILED'  }" :title="item.action_type") {{ item.action_type }}
                td
                  span(:title="item.domain_name") {{ item.domain_name }}
                td
                  span(:title="item.login_ip") {{ item.login_ip }}
                td
                  span(:title="item.browser_agent") {{ item.browser_agent }}
                td.text-right
                  span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcelFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel
  },
  props: {
    currTab: {
      type: String,
      default: ''
    },
    operatorID: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    loading2: false,
    logList: [],
    logListFull: [],
    currentPage: 1,
    totalRow: 0,
    login_ip: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    dateRange: {
      startDate: null,
      endDate: null,
    },
    loginPlatform: 99,
    loginStatus: 99,
    sortKey: "action_date",
    sortType: "desc"
  }),
  computed: {
    getLoginStatus() {
      if (this.loginStatus == 1)
        return 'SUCCESS';
      else if (this.loginStatus == 0)
        return 'FAILED';
      else
        return null;
    },
    getPageSize() {
      return this.$store.getters.pageSizeMemberLog;
    }
  },
  mounted: function() {},
  destroyed: function() {
    var json = {
      start_date: null,
      end_date: null,
      login_ip: '',
      login_status: 99,
    };
    this.$store.dispatch("user/setLoginLogParam", json);
  },
  methods: {
    refresh() {
      if (this.$store.getters.loginLog.login_ip != null && this.$store.getters.loginLog.login_ip != '') {
        this.login_ip = this.$store.getters.loginLog.login_ip;
      }
      if (this.$store.getters.loginLog.login_status != null && this.$store.getters.loginLog.login_status != '') {
        this.loginStatus = this.$store.getters.loginLog.login_status;
      }
      if (this.$store.getters.loginLog.start_date && this.$store.getters.loginLog.end_date) {
        this.dateRange.startDate = this.$store.getters.loginLog.start_date;
        this.dateRange.endDate = this.$store.getters.loginLog.end_date;
      } else {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      }

      this.getLogList(true);
      this.getLogListFull();
    },
    setLoginLogParam: function() {
      var json = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        login_ip: this.login_ip,
        login_status: this.loginStatus
      };
      this.$store.dispatch("user/setLoginLogParam", json);
    },
    sortOrder(key, type) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getLogList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getListing() {
      this.getLogList(true);
      this.getLogListFull();
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getLogList(true);
      this.getLogListFull();
    },
    getLogListFull: function(isSearch) {
      if (this.checkDateRange()) {
        this.setLoginLogParam();
        let url = config.auditLoginMemberUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.memberID,
          login_status: this.getLoginStatus,
          login_ip: this.login_ip,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.logListFull = response.data.dt;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getLogList: function(isSearch) {
      if (this.checkDateRange()) {

        let url = config.auditLoginMemberUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.memberID,
          login_status: this.getLoginStatus,
          login_ip: this.login_ip,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.logList = response.data.dt;
                  this.totalRow = this.logList.length > 0 ? this.logList[0].totalrows : 0;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.totalRow = 0;
        this.logList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'loginlog') return
      this.$store.dispatch("layout/setPageSizeMemberLog", pageSize);
      this.currentPage = 1;
      this.getLogList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getLogList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>